<!--
 * @Description: 
 * @Author: 
 * @Date: 2024-02-24 18:08:34
-->
<template>
  <div id="app" :class="appClasses">
    <router-view></router-view>
  </div>
</template>

<script>
import './assets/css/global.css'
import '@/assets/font/font.css'
export default {
  name: 'app',
  computed: {
    appClasses() {
      const platform = this.$platform || {}
      return [
        'platform-app',
        `platform-${platform.platform || 'pc'}`,
        {
          'is-mobile-layout': !!platform.isMobile,
          'is-mp-webview': !!platform.isMpWebview,
        },
      ]
    }
  }
}
</script>

<style>

</style>
